import { Api } from "./config/request";

export const adminLogin = payload => {
  return Api.postRequest(`admins/login/`, payload);
};

export const Login = {
  adminLogin
};
